<template>
  <ul class="bar-list" :class="{ stacked }">
    <li v-for="item in items" :key="item.key">
      <component :is="item.to ? 'router-link' : 'div'" :to="item.to || null" class="bar-row" :class="{ empty: !item.value }" :title="`${item.label}: ${fa(item.value)}`">
        <span class="bar-label"><i v-if="item.color" class="swatch" :style="{ background: item.color }" />{{ item.label }}</span>
        <span class="bar-track"><span class="bar-fill" :style="{ width: share(item.value) + '%', background: item.color || color }" /></span>
        <span class="bar-value vn-num">{{ fa(item.value) }}</span>
      </component>
    </li>
    <li v-if="!items.length" class="bar-empty">{{ empty }}</li>
  </ul>
</template>

<script>
import { fa } from './format';

export default {
  name: 'BarList',
  props: {
    items: { type: Array, required: true }, // [{ key, label, value, color?, to? }]
    color: { type: String, default: 'var(--navy-700)' },
    stacked: { type: Boolean, default: false }, // label on its own line, for long names
    empty: { type: String, default: 'داده‌ای در این بازه نیست.' },
  },
  computed: { max() { return Math.max(1, ...this.items.map(item => item.value)); } },
  methods: { fa, share(value) { return value ? Math.max(3, (value / this.max) * 100) : 0; } },
};
</script>

<style scoped>
.bar-list { list-style: none; margin: 0; padding: 0; display: grid; gap: 2px; }
.bar-row { display: grid; grid-template-columns: minmax(96px, 36%) 1fr 56px; align-items: center; gap: 10px; min-height: 36px;
  padding: 4px 8px; border-radius: var(--r-sm); color: var(--text-2); font-size: 12.5px; text-decoration: none; }
a.bar-row:hover { background: var(--navy-50); color: var(--text); text-decoration: none; }
a.bar-row:focus-visible { outline: 3px solid var(--focus); outline-offset: 1px; }
.bar-label { display: flex; align-items: center; gap: 7px; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.swatch { flex: none; width: 10px; height: 10px; transform: skewX(var(--slant)); }
.bar-track { height: 10px; background: var(--navy-50); overflow: hidden; display: flex; justify-content: flex-start; }
.bar-fill { height: 100%; transition: width .3s var(--ease-out); }
.bar-value { text-align: left; font-weight: 800; color: var(--navy-900); }
.empty .bar-value, .empty .bar-label { color: var(--text-4); }
.stacked .bar-row { grid-template-columns: 1fr 56px; row-gap: 4px; padding-block: 6px; }
.stacked .bar-label { grid-column: 1 / -1; white-space: normal; }
.bar-empty { padding: 18px 8px; color: var(--text-3); font-size: 12px; text-align: center; }
</style>
